import React from 'react';
import ReactCurrencyInput, { ReactCurrencyInputProps } from 'react-currency-input';

import styled from 'styled-components';

interface CurrencyInputStyledProps extends ReactCurrencyInputProps {
  styledProps: {
    hasError: boolean;
  };
}

export const Input = styled(({ styledProps, ...rest }: CurrencyInputStyledProps) => <ReactCurrencyInput {...rest} />)`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  transition: all 0.3s ease-in-out;
  padding: 12px 15px;
  font-size: 16px;
  border: none;
  color: ${({ theme }) => theme.input.color};
`;

export const InputContainer = styled.div`
  position: relative;
  flex: 1;
`;

interface PlaceholderProps {
  $darkPlaceholder?: boolean;
}

export const Placeholder = styled.p<PlaceholderProps>`
  position: absolute;
  padding: 15px;
  font-size: 16px;
  background: ${({ theme }) => theme.input.active.prefixSuffix};
  color: ${({ theme, $darkPlaceholder }) =>
    $darkPlaceholder ? theme.input.prefixSuffix : theme.input.active.prefixSuffixBackground};
`;

export const Suffix = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  width: 72px;
  color: ${({ theme }) => theme.input.prefixSuffix};
  background-color: ${({ theme }) => theme.input.prefixSuffixBackground};
`;
